// import styled from 'styled-components';
// import palette from '../../../lib/styles/palette';
import React, { useState } from 'react';

// import { Input, RowInput, RowOutput, RowSelect } from './PowerCalculationJIS';
import { useEffect } from 'react';
import { formatSafeValue, motorRanking, selectMotor } from './library-jis';
import { useDispatch, useSelector } from 'react-redux';
import { changeBody, changeField } from '../../../modules/conveyor/conveyorWriteSlice';
import { ErrorMessage, Input, Output, Select } from '../common/SingleInput';
import AlertLabel from '../../common/AlertLabel';
// import { MultiOutput } from '../common/MultiInput';
// import { LoadNoLoadLabel } from '../common/LoadNoLoadLabel';

const DriveFormSingle = ({ drives: prevDrives, resistance, input, output }) => {
    const dispatch = useDispatch();

    const language = useSelector((state) => state.language.language);
    const isEN = language === 'EN' ? true : false;
    const isJP = language === 'JP' ? true : false;
    // const isKR = language === 'KR' ? true : false;

    const [drives] = useState(
        prevDrives && Array.isArray(prevDrives) && prevDrives.length === 1
            ? prevDrives
            : [
                  {
                      description: '1st Drive',
                      distribution: 100,
                  },
              ],
    );

    const { overall: overallResistance } = resistance;
    const {
        length,
        // beltWidth,
        artificialFrictionCoeff,
        beltSpeed,
        carrySpacing,
        returnSpacing,
        pipeDiameter,
        overlapAngle,
    } = input;
    const { slopeAngle, massBelt, massMaterial, massReturnIdler } = output;

    // Tension이 계산되어 다른 컴포넌트에서 사용할 수 있도록 정보 제공
    // const [isValidTension, setIsValidTension] = useState(false);

    // 계산용 변수로 치환
    const g = 9.806;
    // const FU = Number(overallResistance?.load);
    const a0 = Number(carrySpacing);
    const au = Number(returnSpacing);
    const qB = massBelt;
    const qG = massMaterial;
    const qRU = massReturnIdler;
    // const B = Number(beltWidth) / 1000; // m로 환산
    const L = Number(length);
    const delta = (slopeAngle * Math.PI) / 180; // 라디안 변환
    const f = Number(artificialFrictionCoeff);
    const D = Number(pipeDiameter) / 1000; // m로 환산
    const 𝜃 = Number(overlapAngle); // 중첩각. deg.
    const 𝜆 = 𝜃 / (360 + 𝜃); // 중첩각 비율. 무차원 수
    // console.log('D, 𝜃, 𝜆 : ', D, 𝜃, 𝜆);

    // drive 세팅
    const [drive, setDrive] = useState(drives[0]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setDrive((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleMotorSelection = (e) => {
        const { value } = e.target;
        const prevMotor = drive.selectedMotor;
        let _selectedMotor = Number(value);
        if (value < Number(drive.requiredPower)) {
            alert('모터를 다시 선택하세요');
            _selectedMotor = prevMotor;
        }
        setDrive((prev) => ({
            ...prev,
            selectedMotor: _selectedMotor,
        }));
    };

    /* 1st Drive - Effective Tension 계산 */
    useEffect(() => {
        // if (!drive.distribution) return;

        const effectiveTensionLoad = (Number(drive.distribution) / 100) * overallResistance?.load;
        const effectiveTensionNoLoad = (Number(drive.distribution) / 100) * overallResistance?.noLoad;

        setDrive((prev) => ({
            ...prev,
            effectiveTension: {
                load: Math.ceil(effectiveTensionLoad),
                noLoad: Math.ceil(effectiveTensionNoLoad),
            },
        }));
    }, [drive.distribution, overallResistance]);

    /* Actual Power 계산 */
    useEffect(() => {
        // if (!beltSpeed || !drive.distribution || !drive.effectiveTension?.load) {
        //     return;
        // }
        const actualPowerLoad = ((drive.distribution / 100) * drive.effectiveTension?.load * beltSpeed) / 1000;
        const actualPowerNoLoad = ((drive.distribution / 100) * drive.effectiveTension?.noLoad * beltSpeed) / 1000;

        setDrive((prev) => ({
            ...prev,
            actualPower: {
                load: Math.round(actualPowerLoad * 10) / 10,
                noLoad: Math.round(actualPowerNoLoad * 10) / 10,
            },
        }));
    }, [beltSpeed, drive.distribution, drive.effectiveTension]);

    /* Required Power, Selected Motor 계산 */
    useEffect(() => {
        // if (!drive.mechanicalEfficiency) {
        //     return;
        // }
        const actualPower = Math.max(drive.actualPower?.load, drive.actualPower?.noLoad);
        const requiredPower = actualPower / Number(drive.mechanicalEfficiency);

        setDrive((prev) => ({
            ...prev,
            requiredPower: Math.round(requiredPower * 10) / 10,
            // drive.selectedMotor ?? <- 이 구문이 없으면 다시 계산되어 이전에 선택한 값(자동선택이 아닌)이 바뀌어버린다.
            selectedMotor: drive.selectedMotor ?? selectMotor(requiredPower),
        }));
    }, [drive.actualPower, drive.mechanicalEfficiency, drive.selectedMotor]);

    /* Safety Margin 계산 */
    useEffect(() => {
        // if (!drive.requiredPower || !drive.selectedMotor) {
        //     return;
        // }
        const safetyMargin = drive.selectedMotor / drive.requiredPower;
        const isSafe = safetyMargin < 1 ? false : true;

        setDrive((prev) => ({
            ...prev,
            safetyMargin: Math.round(safetyMargin * 100) / 100,
            isSafe: !!isSafe,
        }));
    }, [drive.requiredPower, drive.selectedMotor]);

    /* Motor RPM, Rated Motor Torque 계산 */
    useEffect(() => {
        // if (!drive.frequency || !drive.poles || !drive.selectedMotor || !drive.actualPower) {
        //     return;
        // }
        const revolution = (120 * drive.frequency) / drive.poles;
        const ratedMotorTorque = Math.round(((974 * drive.selectedMotor) / revolution) * 10) / 10;
        const actualTorqueAtMotorShaft = Math.round(((974 * drive.actualPower) / revolution) * 10) / 10;

        setDrive((prev) => ({
            ...prev,
            motorRPM: revolution,
            ratedMotorTorque,
            actualTorqueAtMotorShaft,
        }));
    }, [drive.frequency, drive.poles, drive.selectedMotor, drive.actualPower]);

    useEffect(() => {
        // if (!drive.frictionCoeff || !drive.wrapAngle) {
        //     return;
        // }
        const mu1 = Number(drive.frictionCoeff);
        const theta1 = (Number(drive.wrapAngle) * Math.PI) / 180; // 라디안 변경
        const emutheta = Math.round(Math.pow(Math.E, mu1 * theta1) * 100) / 100;
        const drivingFactor1 = Math.ceil((1 / (Math.pow(Math.E, mu1 * theta1) - 1)) * 1000) / 1000;
        // const drivingFactor = 1 / (Math.pow(Math.E, (drive.frictionCoeff * drive.wrapAngle * Math.PI) / 180) - 1);
        const requiredSlackSideTensionLoad = drive.effectiveTension?.load * drivingFactor1;
        const requiredSlackSideTensionNoLoad = drive.effectiveTension?.noLoad * drivingFactor1;

        setDrive((prev) => ({
            ...prev,
            emutheta,
            drivingFactor: drivingFactor1,
            requiredSlackSideTension: {
                load: Math.ceil(requiredSlackSideTensionLoad),
                noLoad: Math.ceil(requiredSlackSideTensionNoLoad),
            },
        }));
    }, [drive.effectiveTension?.load, drive.effectiveTension?.noLoad, drive.frictionCoeff, drive.wrapAngle]);
    
    /* Min., Max. Tension 계산 */
    /* Driving Factor, Slack Side Tension 계산 */
    useEffect(() => {
        // if (!drive.permissibleSagRatio || Number(drive.permissibleSagRatio) === 0) return;

        // if (!drive.distribution) return;
        // console.log('drive.distribution : ', drive.distribution);

        const mu1 = Number(drive.frictionCoeff);
        const theta1 = (Number(drive.wrapAngle) * Math.PI) / 180; // 라디안 변경
        const emutheta = Math.round(Math.pow(Math.E, mu1 * theta1) * 100) / 100;

        /* Min. Tension의 계산 */
        // 1) sag에 의한 Min. Tension
        const rate = Number(drive.permissibleSagRatio);
        // const _carrySideLoad = Math.ceil((a0 * (qB + qG) * g) / (8 * rate));
        // const _carrySideNoLoad = Math.ceil((a0 * qB * g) / (8 * rate));
        // const _returnSideLoad = Math.ceil((au * qB * g) / (8 * rate));
        // const _returnSideNoLoad = Math.ceil((au * qB * g) / (8 * rate));
        // const _minSagTensionLoad = Math.max(_carrySideLoad, _returnSideLoad);
        // const _minSagTensionNoLoad = Math.max(_carrySideNoLoad, _returnSideNoLoad);

        // In case of Pipe Conveyor
        // 1) Carry Side는 일반 컨베이어와 동일한 방식. 단 처짐 rate는 0.010
        // 2) Return Side는 두가지 방식
        //   ① 트랜지션부 처짐량 제한. 공식은 Carry Side와 동일하지만 rate는 1/60. Transition Length는 Pipe Diameter의 30배
        //   ② 판넬사이 파이프 형상 유지를 위한 최소 장력 계산.

        // 1)
        const _minTension_CSNoLoad = Math.ceil((a0 * qB * g) / (8 * rate));
        const _minTension_CSLoad = Math.ceil((a0 * (qB + qG) * g) / (8 * rate));
        // console.log('_minTension_CSLoad : ', _minTension_CSLoad);

        const _minTension_RSNoLoad_Sag = Math.ceil((au * qB * g) / (8 * rate));
        const _minTension_RSLoad_Sag = Math.ceil((au * qB * g) / (8 * rate));
        // console.log('_minTension_RSLoad_Sag :', _minTension_RSLoad_Sag)

        // 2) -①
        const rateAtTransition = 0.01667; // 1/60
        const l = 30 * D; // TransitionLength. 30 times of Pipe Diameter
        const _minTension_RSNoLoad_Sag_At_Transition = Math.ceil((l * qB * g) / (8 * rateAtTransition)) || 0;
        const _minTension_RSLoad_Sag_At_Transition = Math.ceil((l * qB * g) / (8 * rateAtTransition)) || 0;

        // 2) -②
        const _minTension_RSNoLoad_PipeShape = ((16.7 * (D * 1000)) / 𝜆 + 2500 * qB) * (au ** 2 / (D * 1000)) * g || 0; // 여기서 D는 mm 단위임
        const _minTension_RSLoad_PipeShape = ((16.7 * (D * 1000)) / 𝜆 + 2500 * qB) * (au ** 2 / (D * 1000)) * g || 0; // 여기서 D는 mm 단위임

        const _minTension_RSNoLoad = Math.max(
            _minTension_RSNoLoad_Sag,
            _minTension_RSNoLoad_Sag_At_Transition,
            _minTension_RSNoLoad_PipeShape,
        );
        const _minTension_RSLoad = Math.max(
            _minTension_RSLoad_Sag,
            _minTension_RSLoad_Sag_At_Transition,
            _minTension_RSLoad_PipeShape,
        );
        // console.log(_minTension_RSNoLoad, _minTension_RSLoad);

        // 필요 최소 텐션
        const _minSagTensionLoad = Math.max(_minTension_CSLoad, _minTension_RSLoad);
        const _minSagTensionNoLoad = Math.max(_minTension_CSNoLoad, _minTension_RSNoLoad);

        // 2) Slope에 의한 Tension 감소
        // console.log(L, qB, slopeAngle, delta, f, qRU);
        const _slopeTensionReturnLoad = Math.ceil(L * (qB * Math.sin(delta) - f * (qRU + qB * Math.cos(delta))) * g);
        const _slopeTensionReturnNoLoad = Math.ceil(L * (qB * Math.sin(delta) - f * (qRU + qB * Math.cos(delta))) * g);
        // console.log('slope Tension : ', _slopeTensionReturnLoad);

        // 3) Requied Slack Side Tension to transmit effective tension
        const effectiveTensionLoad = Math.ceil((drive.distribution / 100) * overallResistance?.load);
        const effectiveTensionNoLoad = Math.ceil((drive.distribution / 100) * overallResistance?.noLoad);

        // const requiredSlackSideTensionLoad = Math.ceil(drive.drivingFactor * effectiveTensionLoad);
        // const requiredSlackSideTensionNoLoad = Math.ceil(drive.drivingFactor * effectiveTensionNoLoad);

        const _minTensionLoad = Math.max(
            drive.requiredSlackSideTension?.load, // Driving Factor에 의한 최소 장력
            // Math.max(_carrySideLoad, _returnSideLoad),                                  // 처짐 등에 의한 최소 장력
            Math.max(_minTension_CSLoad, _minTension_RSLoad),
            // Math.max(_carrySideLoad, _returnSideLoad) + _slopeTensionReturnLoad,        // 처짐 등에 의한 최소 장력 + 리턴 슬로프 장력
            Math.max(_minTension_CSLoad, _minTension_RSLoad) + _slopeTensionReturnLoad,
        );
        const _minTensionNoLoad = Math.max(
            drive.requiredSlackSideTension?.noLoad,
            // Math.max(_carrySideNoLoad, _returnSideNoLoad),
            Math.max(_minTension_CSNoLoad, _minTension_RSNoLoad),
            // Math.max(_carrySideNoLoad, _returnSideNoLoad) + _slopeTensionReturnNoLoad,
            Math.max(_minTension_CSNoLoad, _minTension_RSNoLoad) + _slopeTensionReturnNoLoad,
        );

        const T2Load = _minTensionLoad;
        const T1Load = effectiveTensionLoad + T2Load;
        // console.log('T1Load : ', T1Load);
        const ratioLoad = Math.round((T1Load / T2Load) * 100) / 100;
        const errorMessageLoad = ratioLoad > emutheta ? 'Check!' : '';

        const T2NoLoad = _minTensionNoLoad;
        const T1NoLoad = effectiveTensionNoLoad + T2NoLoad;
        const ratioNoLoad = Math.round((T1NoLoad / T2NoLoad) * 100) / 100;
        const errorMessageNoLoad = ratioNoLoad > emutheta ? 'Check!' : '';

        /* effectiveTension Load / No Load 둘 중 큰 값으로 Max. Tension을 계산한다. */
        const effectiveTension = Math.max(effectiveTensionLoad, effectiveTensionNoLoad);
        // const minTension = Math.max(_minTensionLoad, _minTensionNoLoad);

        // Max. Tension 계산
        const _max1 =
            effectiveTension + Math.max(drive.requiredSlackSideTension?.load, drive.requiredSlackSideTension?.noLoad);
        // const _max2 = effectiveTension + Math.max(_carrySideLoad, _returnSideLoad);
        const _max2 = effectiveTension + _minSagTensionLoad;
        // const _max3 = effectiveTension + Math.max(_carrySideLoad, _returnSideLoad) + _slopeTensionReturnLoad;
        const _max3 = effectiveTension + _minSagTensionNoLoad + _slopeTensionReturnLoad;
        const _maxTension = Math.max(_max1, _max2, _max3);

        // console.log('max : ', _max1, _max2, _max3, _maxTension);

        setDrive((prev) => ({
            ...prev,
            minCarry: {
                // load: Math.ceil(_carrySideLoad),
                load: _minTension_CSLoad,
                // noLoad: Math.ceil(_carrySideNoLoad),
                noLoad: _minTension_CSNoLoad,
            },
            minReturn: {
                // load: Math.ceil(_returnSideLoad),
                load: _minTension_RSLoad,
                // noLoad: Math.ceil(_returnSideNoLoad),
                noLoad: _minTension_RSNoLoad,
            },
            minSagTension: {
                load: Math.ceil(_minSagTensionLoad),
                noLoad: Math.ceil(_minSagTensionNoLoad),
            },
            slopeTensionReturn: {
                load: Math.ceil(_slopeTensionReturnLoad),
                noLoad: Math.ceil(_slopeTensionReturnNoLoad),
            },
            maxTension1: Math.ceil(_max1),
            maxTension2: Math.ceil(_max2),
            maxTension3: Math.ceil(_max3),
            maxTension: Math.ceil(_maxTension),
            tightSideTension: {
                load: T1Load,
                noLoad: T1NoLoad,
            },
            slackSideTension: {
                load: T2Load,
                noLoad: T2NoLoad,
            },
            ratio: {
                load: ratioLoad,
                noLoad: ratioNoLoad,
            },
            errorMessage: {
                load: errorMessageLoad,
                noLoad: errorMessageNoLoad,
            },
        }));
    }, [
        D,
        L,
        a0,
        au,
        delta,
        drive.distribution,
        drive.frictionCoeff,
        drive.permissibleSagRatio,
        drive.requiredSlackSideTension?.load,
        drive.requiredSlackSideTension?.noLoad,
        drive.wrapAngle,
        f,
        overallResistance?.load,
        overallResistance?.noLoad,
        qB,
        qG,
        qRU,
        𝜆,
    ]);

    /* 리덕스에 쓰기 */
    useEffect(() => {
        dispatch(
            changeBody({
                key: 'drives',
                value: [drive],
            }),
        );
    }, [dispatch, drive]);

    // Tension 계산이 완료되어 다른 컴포넌트에서 사용할 수 있음을 알려주는 상태를 store에 저장
    // dispatch(
    //     changeField({
    //         key: 'isValidTension',
    //         value: isValidTension,
    //     }),
    // );
    useEffect(() => {
        if (drive.tightSideTension?.load) {
            dispatch(
                changeField({
                    key: 'isValidTension',
                    value: true,
                }),
            );
        }
    }, [dispatch, drive.tightSideTension]);

    return (
        <>
            <Output
                label="Drive Description"
                variable="-"
                unit="-"
                variableName="description"
                value={drive.description}
                // referenceValue={'1st Drive'}
                // onChange={handleChange}
            />
            <Input
                label="Power(Tension) Distribution"
                variable="-"
                unit="%"
                variableName="distribution"
                value={drive.distribution}
                referenceValue={100}
                onChange={handleChange}
            />
            <Output
                label="Effective Tension"
                variable="FU"
                unit="-"
                variableName="effectiveTension"
                value={Math.max(drive.effectiveTension?.load, drive.effectiveTension?.noLoad)}
            />
            <Output
                label="Actual Power"
                variable="Pa"
                variableName="actualPower"
                unit="kW"
                value={Math.max(drive.actualPower?.load, drive.actualPower?.noLoad)}
            />
            <Input
                label="Mechanical Efficiency"
                variable="etha"
                unit="-"
                variableName="mechanicalEfficiency"
                value={drive.mechanicalEfficiency}
                referenceValue={0.9}
                onChange={handleChange}
            />
            <Output
                label="Motor Power Required"
                variable="PM"
                variableName="requiredPower"
                unit="kW"
                value={drive.requiredPower}
            />
            <Select
                label="Motor Selected"
                variable="-"
                variableName="selectedMotor"
                unit="kW"
                value={drive.selectedMotor}
                options={motorRanking}
                onChange={handleMotorSelection}
                isRequired
            />
            <Output
                label="Safety Margin(裕度)"
                variable="-"
                variableName="safetyMargin"
                unit="-"
                value={drive.safetyMargin}
                isSafe={drive.isSafe}
            />
            <Input
                label="Slip Ratio"
                variable="-"
                unit="%"
                variableName="slipRatio"
                value={drive.slipRatio}
                referenceValue={3.0}
                onChange={handleChange}
            />
            <Select
                label="Frequency"
                variable="-"
                variableName="frequency"
                unit="Hz"
                value={drive.frequency}
                options={[
                    { text: '50Hz', value: 50 },
                    { text: '60Hz', value: 60 },
                ]}
                onChange={handleChange}
                isRequired
            />
            <Select
                label="Number of Poles"
                variable="-"
                variableName="poles"
                unit="-"
                value={drive.poles}
                options={[
                    { text: '4P', value: 4 },
                    { text: '6P', value: 6 },
                    { text: '8P', value: 8 },
                ]}
                onChange={handleChange}
                isRequired
            />
            <Output label="Motor RPM" variable="N" unit="1/min" variableName="motorRPM" value={drive.motorRPM} />
            <Output
                label="Rated Motor Torque"
                variable="Tm"
                unit="Nm"
                variableName="ratedMotorTorque"
                value={drive.ratedMotorTorque}
            />
            <Input
                label="Wrap Angle"
                variable="-"
                unit="-"
                variableName="wrapAngle"
                value={drive.wrapAngle}
                referenceValue={200}
                onChange={handleChange}
            />
            <Input
                label="Friction Coefficient between Pulley Lagging and Belt"
                variable="-"
                unit="-"
                variableName="frictionCoeff"
                value={drive.frictionCoeff}
                referenceValue={0.3}
                onChange={handleChange}
            />
            <Output
                label="Driving Factor"
                variable="-"
                unit="-"
                variableName="drivingFactor"
                value={drive.drivingFactor}
            />
            <Output
                label="Minimum Slackside Tension to Transmit Effective Tension"
                variable="F2"
                unit="N"
                variableName="requiredSlackSideTension"
                value={drive.requiredSlackSideTension?.load}
            />
            <Input
                isSub
                label="Permissible Slack Rate between the Idlers(0.05 ~ 0.02)"
                variable="h/a"
                variableName="permissibleSagRatio"
                unit="-"
                value={drive.permissibleSagRatio}
                referenceValue={0.012}
                onChange={handleChange}
            />
            <Output
                label="Minimum Belt Tension Required"
                variable="Fmin"
                variableName="minSagTension"
                unit="N"
                value={formatSafeValue(drive.minSagTension?.load)}
            />
            <Output
                isSub
                label="Carry"
                variable="FminCarry"
                variableName="minCarry"
                unit="N"
                value={formatSafeValue(drive.minCarry?.load)}
            />
            <Output
                isSub
                label="Return"
                variable="FminReturn"
                variableName="minReturn"
                unit="N"
                value={formatSafeValue(drive.minReturn?.load)}
            />
            <Output
                label="Return-side Belt Tension (at Head due to Slope)"
                variable="F3"
                variableName="slopeTensionReturn"
                unit="N"
                value={formatSafeValue(drive.slopeTensionReturn?.load)}
            />
            <Output label="Max. Tension" variable="Fmax" variableName="maxTension" unit="N" value={drive.maxTension} />
            <Output
                label="Fmax = FU + F2"
                variable=""
                variableName="maxTension1"
                unit="N"
                value={drive.maxTension1}
                isSub
            />
            <Output
                label="Fmax = FU + Fmin"
                variable=""
                variableName="maxTension2"
                unit="N"
                value={drive.maxTension2}
                isSub
            />
            <Output
                label={
                    <AlertLabel
                        label="Fmax = FU + Fmin + F3"
                        message={
                            isEN
                                ? 'The calculation assumes the most common case where the take-up is located at the head section. In other cases, this value does not need to be considered.'
                                : isJP
                                ? 'テイクアップがヘッド部にある一般的な場合を想定して計算しています。それ以外の場合には、この数値を考慮する必要はありません。'
                                : '테이크업이 헤드부에 있는 가장 일반적인 경우를 고려하여 계산함. 그 외의 경우에는 본 수치는 고려하지 않아도 됨.'
                        }
                    />
                }
                variable=""
                variableName="maxTension3"
                unit="N"
                value={drive.maxTension3}
                isSub
            />
            {/* <Output
                label="Tight Side Tension"
                variable="F1"
                unit="N"
                variableName="tightSideTension"
                value={drive.tightSideTension?.load}
            />
            <Output
                label="Tight Side Tension(No Load)"
                variable="F1"
                unit="N"
                variableName="tightSideTension"
                value={drive.tightSideTension?.noLoad}
            /> */}
            {/* <LoadNoLoadLabel /> */}
            <Output
                label="Tight Side Tension"
                variable="F1"
                unit="N"
                variableName="tightSideTension"
                value={drive.tightSideTension?.load}
            />
            {/* <Output
                label="Slack Side Tension"
                variable="F2"
                unit="N"
                variableName="slackSideTension"
                value={drive.slackSideTension?.load}
            />
            <Output
                label="Slack Side Tension(No Load)"
                variable="F2"
                unit="N"
                variableName="slackSideTension"
                value={drive.slackSideTension?.noLoad}
            /> */}
            <Output
                label="Slack Side Tension"
                variable="F2"
                unit="N"
                variableName="slackSideTension"
                value={drive.slackSideTension?.load}
            />
            {drive.errorMessage?.load && (
                <ErrorMessage
                    label={
                        <AlertLabel
                            label="Error Message"
                            message={isEN ? '' : isJP ? '' : '벨트 감김각과 풀리 래깅의 마찰계수를 조정하세요.'}
                        />
                    }
                    variable="F2"
                    unit="N"
                    variableName="errorMessage"
                    value={drive.errorMessage?.load}
                />
            )}
        </>
    );
};

export default DriveFormSingle;
